//function to change the button text
function filterProductsBySelect() {
    var selectedFilters = {};

    // Collect selected filters from select boxes
    $('#filters select').each(function() {
        var category = $(this).data('category');
        var value = $(this).val();
        if (value && value !== 'all') {
            selectedFilters[category] = value;
        }
    });

    $('#gallery-grid .gallery-item').each(function() {
        var showProduct = true;
        var productClasses = $(this).attr('class').split(' ');

        for (var category in selectedFilters) {
            if (!productClasses.includes(selectedFilters[category])) {
                showProduct = false;
                break;
            }
        }

        if (showProduct) {
            $(this).removeClass('hidden').removeClass('invisible');
        } else {
            $(this).addClass('hidden');
        }
    });

    setTimeout(function() {
        $('#gallery-grid .gallery-item.hidden').each(function() {
            $(this).addClass('invisible');
        });
    }, 200);
}

$('#filters select').on('change', filterProductsBySelect);
function changeText() {
    var link = $("#btn-filter");
    if (link.text() === "Filtre") {
        link.text("Fermer");
    } else {
        link.text("Filtre") ;
    }
}  

$(document).ready(function(){



    $('#filter-toggle-button').on('click', function(){
        $('#filters').toggleClass('open');
        $('#filter-toggle-button').toggleClass('actif');
        $('.gallery-overlay').toggleClass('open');
    });
    $('.gallery-overlay').on('click', function(){
        $('.gallery-overlay').toggleClass('open');
        $('#filters').toggleClass('open');
        $('#filter-toggle-button').toggleClass('actif');
        changeText();
    });





    $('#search-input').on('keyup', function(){
        var searchText = $(this).val().toLowerCase();
        $('#gallery-grid .gallery-item').each(function() {
           var productTitle = $(this).find('h5').text().toLowerCase();
            if (productTitle.includes(searchText)) {
                $(this).removeClass('hidden').removeClass('invisible');//.show();
            } else {
                $(this).addClass('hidden');//.hide();
            }
           // $(this).toggleClass('hidden', !productTitle.includes(searchText));
        });
    });
});